<template>
  <Grid class="grid-gutter-md">
    <template v-if="hasCashlessPay || editCashlessPay">
      <Col6>
        <Type />
      </Col6>

      <!-- Due to vshow nature -->
      <div class="col-12" v-show="isFreedomPay">
        <FreedomPay />
      </div>

      <Col12>
        <Tenders :isDisabled="!editCashlessPay" :mealPlanType="cashlessPayType" />
      </Col12>
    </template>

    <template v-else-if="!editCashlessPay">
      <Col12>
        {{ t('sites.singleSite.financialConfig.cashlessPay.empty') }}
      </Col12>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useFieldValue } from 'vee-validate';
import { useCashlessPay } from '../composables';
import { computed } from 'vue';
import FreedomPay from './freedom-pay/FreedomPay.vue';
import { storeToRefs } from 'pinia';
import Type from '../fields/type/Type.vue';
import { useFinancialConfigStore } from '../../../../../routes';
import { FREEDOM_PAY_TYPES } from '../../enums';
import Tenders from './../../tenders/Tenders.vue';

// Set localization
const { t } = useI18n();

// Set cashless pay composable
const { hasCashlessPay } = useCashlessPay();

// Set financial conmfig store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);

// Set cashless pay type field value
const cashlessPayType = useFieldValue<string>('type');

// Check if cashless pay type is FreedomPay
const isFreedomPay = computed<boolean>(() => FREEDOM_PAY_TYPES.includes(cashlessPayType.value));
</script>
